export default __webpack_public_path__ + "static/media/GenieCamellia.964d654e.jpg";